import { render, staticRenderFns } from "./TypingIndicator.vue?vue&type=template&id=1687c528&"
var script = {}
import style0 from "./TypingIndicator.vue?vue&type=style&index=0&id=1687c528&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports